import { ENodeEnv } from '../store/enum';

export const baseURL = process.env.NODE_ENV == ENodeEnv.Production ? '/api' : 'https://localhost:44387/api';
